<script lang="ts">
import { useTextColor } from 'vuetify/lib/composables/color.mjs'

export default defineComponent({
  name: 'TextDefault',
  props: {
    color: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    ...useTagProps(),
    ...useDimensionProps(),
    ...useFontSizeProps(),
  },
  setup(props, { slots }) {
    const { textColorClasses, textColorStyles } = useTextColor(toRef(props, 'color'))
    const { dimensionStyles } = useDimension(props)
    const { fontSizeStyles } = useFontSize(props)

    return () => h(props.tag, {
      class: [
        'u-text',
        textColorClasses.value,
      ],
      style: {
        ...dimensionStyles.value,
        ...fontSizeStyles.value,
        ...textColorStyles.value,
      },
    }, slots.default?.() ?? props.text)
  },
})
</script>
